import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Tag,
  Upload as UploadAntd,
  Image,
  DatePicker,
  Space,
  Radio,
  Dropdown,
  Menu,
  Badge,
  Tooltip,
  Checkbox,
  Divider,
  Switch,
} from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import Noimage from "../assets/images/noimage_newww.png";
import * as XLSX from "xlsx";
import moment from "moment";
import apiPath from "../constants/apiPath";
import {
  ExclamationCircleOutlined,
  FilterFilled,
  UploadOutlined,
  EyeOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  DownloadOutlined,
  WarningOutlined,
  ReloadOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";
import PhoneinputField from "../components/PhoneInputField";
import lang from "../helper/lang";
import SingleImageUpload from "../components/SingleImageUpload";
import MultipleImageUpload from "../components/MultipleImageUpload";
import notfound from "../assets/images/not_found.png";
import ContractManagement from "./ContractManagement";

import { Select } from "antd";
const { Option } = Select;

const { RangePicker } = DatePicker;

const Search = Input.Search;
// Uploads now go through the backend (POST /admin/media/upload), which
// holds the real AWS credentials server-side and never exposes them. This
// used to upload straight to S3 from the browser with a hardcoded access
// key + secret baked into this file — visible to anyone via view-source on
// the deployed site, no login required. See MediaUploadController.ts.

let baseURL = apiPath.customerManager;

const CONTRACT_CURRENCY_SYMBOLS = {
  USD: "$",
  INR: "₹",
  EUR: "€",
  GBP: "£",
  AED: "AED ",
  SAR: "SAR ",
};
const contractCurrencySymbol = (code) =>
  CONTRACT_CURRENCY_SYMBOLS[code] || (code ? code + " " : "$");

// One-click password for BD Demo accounts — 12 chars, guaranteed to satisfy
// the form's own rule (upper + lower + number). Never persisted client-side;
// it only ever leaves this browser as the create-account request body, and
// the backend emails it straight to the demo user (demoAccountEmailTemplate).
const generateDemoPassword = () => {
  const upper = "ABCDEFGHJKLMNPQRSTUVWXYZ";
  const lower = "abcdefghijkmnpqrstuvwxyz";
  const digits = "23456789";
  const symbols = "!@#$%";
  const all = upper + lower + digits + symbols;
  const pick = (set) => set[Math.floor(Math.random() * set.length)];
  const required = [pick(upper), pick(lower), pick(digits), pick(symbols)];
  const rest = Array.from({ length: 8 }, () => pick(all));
  return [...required, ...rest].sort(() => Math.random() - 0.5).join("");
};

// Custom filter panel for the merged "Team" column — Brand Manager and Brand
// Strategist stay two independent server-side filters under the hood (same
// bmFilter/bsFilter query params as before), just presented as one dropdown
// with two labeled sections instead of two separate column filter icons.
// Local state here (not AntD's built-in filterDropdown props) so both
// sections can be edited together before a single Apply commits both at once.
function TeamFilterDropdown({ bmOptions, bsOptions, initialBM, initialBS, onApply, onClose }) {
  const [bm, setBm] = useState(initialBM || []);
  const [bs, setBs] = useState(initialBS || []);
  return (
    <div style={{ padding: 12, width: 240 }}>
      <div style={{ fontWeight: 600, fontSize: 12, color: "#888", marginBottom: 6 }}>
        BRAND MANAGER
      </div>
      <Checkbox.Group
        style={{ display: "flex", flexDirection: "column", gap: 4, maxHeight: 140, overflowY: "auto" }}
        value={bm}
        onChange={setBm}
        options={bmOptions.map((o) => ({ label: o.name, value: o.id }))}
      />
      <Divider style={{ margin: "10px 0" }} />
      <div style={{ fontWeight: 600, fontSize: 12, color: "#888", marginBottom: 6 }}>
        BRAND STRATEGIST
      </div>
      <Checkbox.Group
        style={{ display: "flex", flexDirection: "column", gap: 4, maxHeight: 140, overflowY: "auto" }}
        value={bs}
        onChange={setBs}
        options={bsOptions.map((o) => ({ label: o.name, value: o.id }))}
      />
      <Divider style={{ margin: "10px 0" }} />
      <Space style={{ width: "100%", justifyContent: "space-between" }}>
        <Button
          size="small"
          type="link"
          onClick={() => {
            setBm([]);
            setBs([]);
            onApply([], []);
            onClose();
          }}
        >
          Reset
        </Button>
        <Button
          size="small"
          type="primary"
          onClick={() => {
            onApply(bm, bs);
            onClose();
          }}
        >
          OK
        </Button>
      </Space>
    </div>
  );
}

// Generic single checkbox-list filter panel — replaces AntD's built-in
// `filters` dropdown UI for columns where Reset needs to apply immediately.
// The default dropdown's own Reset only clears the checkboxes; it doesn't
// actually confirm/apply until OK is clicked afterward too (so clicking
// Reset alone looks like it does nothing — the exact bug reported). Reset
// here calls onApply([]) + close() together, same one-click behavior as
// TeamFilterDropdown's Reset above.
function CheckboxFilterDropdown({ options, initial, onApply, onClose, width = 200, maxHeight }) {
  const [selected, setSelected] = useState(initial || []);
  return (
    <div style={{ padding: 12, width }}>
      <Checkbox.Group
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 6,
          ...(maxHeight ? { maxHeight, overflowY: "auto" } : {}),
        }}
        value={selected}
        onChange={setSelected}
        options={options}
      />
      <Divider style={{ margin: "10px 0" }} />
      <Space style={{ width: "100%", justifyContent: "space-between" }}>
        <Button
          size="small"
          type="link"
          onClick={() => {
            setSelected([]);
            onApply([]);
            onClose();
          }}
        >
          Reset
        </Button>
        <Button
          size="small"
          type="primary"
          onClick={() => {
            onApply(selected);
            onClose();
          }}
        >
          OK
        </Button>
      </Space>
    </div>
  );
}

function User({ type }) {
  const { userPermission, userProfile } = useContext(AuthContext) || {
    userPermission: [],
  };
  const isAdmin = userProfile?.type || "";
  let permissionObject = {
    add: true,
    edit: true,
    delete: true,
  };
  // const permissionMap = (userPermission ?? []).reduce((acc, item) => {
  //   acc[item.name] = item;
  //   return acc;
  // }, {});
  // console.log(permissionMap)

  // if(isAdmin !== "Admin" && permissionMap["gamerManager"]) {
  //   permissionObject.add = permissionMap["gamerManager"].add;
  //   permissionObject.edit = permissionMap["gamerManager"].edit;
  //   permissionObject.delete =  permissionMap["gamerManager"].view;
  //   console.log(permissionMap["gamerManager"]);
  //   console.log(permissionObject);
  // }
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [listExport, setListExport] = useState([]);
  // Bulk-select (row checkboxes) so Admin can delete several client accounts
  // at once — same rowSelection/bulk-delete pattern BrandManager.js already
  // has for the Staff table, added here per direct request ("put that
  // checkbox on clients also like we have on brands").
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleView, setVisibleView] = useState(false);
  const [provideSession, setProvideSession] = useState(false);
  const [selected, setSelected] = useState();
  const [viewData, setViewData] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [filter, setFilter] = useState();
  const [isRKModalVisible, setIsRKModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [rowFilter, setRowFilter] = useState({});
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState([]);
  const [isCustomerDetailsVisible, setIsCustomerDetailsVisible] =
    useState(false);
  const [file, setFile] = useState([]);

  // Per-customer pause
  const [pauseModalVisible, setPauseModalVisible] = useState(false);
  const [pauseTarget, setPauseTarget] = useState(null);
  const [pauseForm] = Form.useForm();

  // Inactivity notice
  const [inactiveModalVisible, setInactiveModalVisible] = useState(false);
  const [inactiveTarget, setInactiveTarget] = useState(null);
  const [inactiveForm] = Form.useForm();

  // Manage Assistants (full list + add/edit/enable/disable/reset/delete on
  // behalf of the Client) — navigates to the same Assistants tab used on
  // the Client detail page (admin-Imergey/src/pages/accessModule/AssistantsTab.js,
  // viewclients.js's ?tab=assistants). Previously this opened AssistantsTab
  // embedded in a Modal here instead — but AssistantsTab opens its own
  // Add/Edit and Audit Log modals, and nesting a Modal inside a Modal
  // produced a broken/clipped position for the inner one. Navigating to the
  // page (same as every other client-management shortcut in this app) also
  // matches how the equivalent brand-manager flow works — no modal ever
  // opens on top of another one there.

  // Column filter dropdown options for Name / Email / Brand Manager /
  // Brand Strategist / Assistant — fetched once from every customer (not
  // just the loaded page), so these filters and the search bar cover the
  // whole list.
  const [filterOptions, setFilterOptions] = useState({
    names: [],
    emails: [],
    brandManagers: [],
    brandStrategists: [],
    assistants: [],
  });

  // New states for trial functionality
  const [extendDaysModalVisible, setExtendDaysModalVisible] = useState(false);
  const [selectedUserForExtend, setSelectedUserForExtend] = useState(null);
  const [selectedDays, setSelectedDays] = useState(1);

  // Contract management states
  const [contractModalVisible, setContractModalVisible] = useState(false);
  const [selectedClientForContract, setSelectedClientForContract] = useState(null);

  // Status filter (Active / Inactive / Trial Active) + counts shown in the Filter dropdown
  const [customerFilter, setCustomerFilter] = useState(null); // null | 'active' | 'inactive' | 'trial'
  const [statusCounts, setStatusCounts] = useState({
    all: 0,
    active: 0,
    inactive: 0,
    trial: 0,
    demo: 0,
  });

  // A plain "N/A" string/tag reads with the same visual weight as real data
  // (a green "Active" tag right next to a "N/A" tag look equally important),
  // making a table full of empty fields look busier than it is. A muted dash
  // recedes instead of competing for attention.
  const emptyCell = <span style={{ color: "#bbb" }}>—</span>;

  const columns = [
    {
      // Merged Profile + Name — the standalone thumbnail column carried no
      // filter/sort of its own (pure decoration next to Name), so folding it
      // into one "Client" cell (avatar + name) loses zero functionality
      // while cutting a whitespace-only column. Pinned left (fixed: "left")
      // so scanning down a scrolled-right row never loses track of who the
      // row belongs to — Actions deliberately stays unpinned per request.
      title: "Client",
      key: "name",
      fixed: "left",
      width: 220,
      // Server-side filter: dropdown options come from every customer
      // (filterOptions.names, fetched from /admin/customer/filter-options),
      // and the selected values are sent to the backend as `nameFilter` —
      // this filters/sorts the WHOLE list, not just the loaded page.
      // Custom dropdown (not AntD's default checkbox-list UI) — that
      // default's Reset button only clears checkboxes without confirming,
      // needing a follow-up OK click to actually apply (the reported bug,
      // also found here and on Email/Activity/Account Status).
      filterIcon: () => (
        <FilterFilled style={{ color: rowFilter.name?.length ? "#1890ff" : undefined }} />
      ),
      filterDropdown: ({ close }) => (
        <CheckboxFilterDropdown
          options={filterOptions.names.map((name) => ({ label: name, value: name }))}
          initial={rowFilter.name || []}
          maxHeight={220}
          onApply={(vals) => {
            const updated = { ...rowFilter, name: vals };
            setRowFilter(updated);
            setPagination((prev) => ({ ...prev, current: 1 }));
            fetchData({ ...pagination, current: 1 }, updated);
          }}
          onClose={close}
        />
      ),
      sorter: (a, b) =>
        String(a.name || a.userName || "").localeCompare(
          String(b.name || b.userName || "")
        ),
      render: (_, { name, userName, image, isDemo }) => (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {image ? (
            <Image
              src={image}
              alt="Profile"
              style={{ width: 28, height: 28, borderRadius: 8, objectFit: "cover", flexShrink: 0 }}
            />
          ) : (
            <div className="main-new-class-image-no" style={{ width: 28, height: 28, flexShrink: 0 }}>
              <img src={Noimage} alt="" style={{ width: "100%", height: "100%" }} />
            </div>
          )}
          <span style={{ fontWeight: 600 }}>{name ? name : userName}</span>
          {isDemo && (
            <Tag color="purple" style={{ marginInlineEnd: 0 }}>
              Internal
            </Tag>
          )}
        </div>
      ),
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
      filterIcon: () => (
        <FilterFilled style={{ color: rowFilter.email?.length ? "#1890ff" : undefined }} />
      ),
      filterDropdown: ({ close }) => (
        <CheckboxFilterDropdown
          options={filterOptions.emails.map((email) => ({ label: email, value: email }))}
          initial={rowFilter.email || []}
          maxHeight={220}
          onApply={(vals) => {
            const updated = { ...rowFilter, email: vals };
            setRowFilter(updated);
            setPagination((prev) => ({ ...prev, current: 1 }));
            fetchData({ ...pagination, current: 1 }, updated);
          }}
          onClose={close}
        />
      ),
      sorter: (a, b) => String(a.email || "").localeCompare(String(b.email || "")),
    },
    {
      // Merged Brand Manager + Brand Strategist into one "Team" column with
      // role-tagged chips — both remain independent server-side filters
      // (bmFilter/bsFilter query params, exactly as before), just presented
      // through one combined dropdown (TeamFilterDropdown) instead of two
      // separate filter icons eating horizontal space.
      title: "Associated Staff",
      key: "team",
      filterIcon: () => (
        <FilterFilled
          style={{
            color: rowFilter.brandManager?.length || rowFilter.brandStrategist?.length ? "#1890ff" : undefined,
          }}
        />
      ),
      filterDropdown: ({ close }) => (
        <TeamFilterDropdown
          bmOptions={filterOptions.brandManagers}
          bsOptions={filterOptions.brandStrategists}
          initialBM={rowFilter.brandManager || []}
          initialBS={rowFilter.brandStrategist || []}
          onApply={(bm, bs) => {
            const updated = { ...rowFilter, brandManager: bm, brandStrategist: bs };
            setRowFilter(updated);
            setPagination((prev) => ({ ...prev, current: 1 }));
            fetchData({ ...pagination, current: 1 }, updated);
          }}
          onClose={close}
        />
      ),
      sorter: (a, b) =>
        String(a.brandManager?.[0]?.name || "").localeCompare(
          String(b.brandManager?.[0]?.name || "")
        ),
      render: (_, { brandManager, brandStrategist }) => {
        const hasBM = brandManager && brandManager.length > 0;
        const hasBS = brandStrategist && brandStrategist.length > 0;
        if (!hasBM && !hasBS) return emptyCell;
        return (
          <div className="staff-role-list">
            {hasBM && (
              <div className="staff-role-row">
                <span className="staff-role-badge staff-role-badge-bm">BM</span>
                <span className="staff-role-name">{brandManager.map((d) => d.name).join(", ")}</span>
              </div>
            )}
            {hasBS && (
              <div className="staff-role-row">
                <span className="staff-role-badge staff-role-badge-bs">BS</span>
                <span className="staff-role-name">{brandStrategist.map((d) => d.name).join(", ")}</span>
              </div>
            )}
          </div>
        );
      },
    },

    {
      title: "Assistant",
      dataIndex: "assistants",
      key: "assistants",
      // Server-side filter, same pattern as Client/Email/Team above — the
      // real assignment lives on AssistantAssignment (an Assistant can be
      // assigned to multiple Clients), not on the Client doc itself, so
      // this needed its own filter-options endpoint addition + assistantFilter
      // query param (CustomerController.list/filterOptions) rather than
      // reusing Team's existing plumbing.
      filterIcon: () => (
        <FilterFilled style={{ color: rowFilter.assistants?.length ? "#1890ff" : undefined }} />
      ),
      filterDropdown: ({ close }) => (
        <CheckboxFilterDropdown
          options={filterOptions.assistants.map((a) => ({ label: a.name, value: a.id }))}
          initial={rowFilter.assistants || []}
          maxHeight={220}
          onApply={(vals) => {
            const updated = { ...rowFilter, assistants: vals };
            setRowFilter(updated);
            setPagination((prev) => ({ ...prev, current: 1 }));
            fetchData({ ...pagination, current: 1 }, updated);
          }}
          onClose={close}
        />
      ),
      // Stacked one-per-line instead of comma-joined on one line — a client
      // with 2+ assistants was forcing this whole column (and everything
      // after it) much wider than it needed to be just to fit one long row.
      render: (_, { assistants }) => {
        if (!assistants || assistants.length === 0) return emptyCell;
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {assistants.map((a, i) => (
              <span key={a._id || i}>{a.name}</span>
            ))}
          </div>
        );
      },
    },

    {
      // Renamed from "STATUS" — this column is really the 14-day
      // activity-based signal (Active/Inactive), plus Paused/Deleted, and
      // was easy to mistake for account/billing standing. The new "Account
      // Status" column just after this one covers payment/renewal state.
      // Trial Status used to be its own standalone column — folded in here
      // (a small secondary tag under the main status) since it's really a
      // sub-state of activity status, not an independent fact, and it was
      // "—" for every client except the rare one actually on trial. Its own
      // column-level filter is dropped; the toolbar's "Filter" button
      // already covers "Trial Active" as one of its options.
      title: "Activity Status",
      key: "isActive",
      // This filter is genuinely server-side (fetchData sends status=/
      // paused= and CustomerController filters by them for real) — AntD's
      // default `filters`+`onFilter` UI was redundant client-side
      // re-filtering on top of already-filtered data, and its Reset button
      // only clears the checkboxes without confirming (needs a follow-up OK
      // click to actually apply) — exactly the "Reset does nothing" bug.
      // Custom dropdown, same one-click Reset pattern as Team's.
      filterIcon: () => (
        <FilterFilled style={{ color: rowFilter.isActive?.length ? "#1890ff" : undefined }} />
      ),
      filterDropdown: ({ close }) => (
        <CheckboxFilterDropdown
          options={[
            { label: "Active", value: true },
            { label: "InActive", value: false },
            { label: "Pause", value: "pause" },
          ]}
          initial={rowFilter.isActive || []}
          onApply={(vals) => {
            const updated = { ...rowFilter, isActive: vals };
            setRowFilter(updated);
            setPagination((prev) => ({ ...prev, current: 1 }));
            fetchData({ ...pagination, current: 1 }, updated);
          }}
          onClose={close}
        />
      ),
      sorter: (a, b) => {
        const rank = (r) => (r.is_deleted ? 0 : r.isPaused ? 1 : r.activityActive ? 3 : 2);
        return rank(a) - rank(b);
      },
      render: (_, record) => {
        const { is_deleted, isPaused, activityActive, subscription } = record;
        const isOnTrial = subscription?.isTrial;
        const trialTag = isOnTrial && (
          <Tag color={subscription.trialExpired ? "red" : "blue"} style={{ marginTop: 4 }}>
            {subscription.trialExpired ? "Trial Ended" : "Trial Active"}
          </Tag>
        );
        const wrap = (statusTag) => (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 0 }}>
            {statusTag}
            {trialTag}
          </div>
        );
        if (is_deleted) {
          return wrap(<Tag color="red">DELETED</Tag>);
        }
        // Checked before activityActive: the filter dropdown and sorter above
        // both already treat "Pause" as its own distinct state, but this
        // render previously never looked at isPaused at all — a paused
        // customer who'd been active in the last 14 days showed as a plain
        // green "Active" tag, same as everyone else, with no visual
        // indication they're actually paused (can't even log in).
        if (isPaused) {
          return wrap(<Tag color="orange">Paused</Tag>);
        }
        if (activityActive) {
          return wrap(<Tag color="green">Active</Tag>);
        }
        // Inactive (no activity in 14 days) — clickable to send a reason notice
        return wrap(
          <Tag
            color="red"
            style={{ cursor: "pointer" }}
            title="Inactive for 14+ days. Click to send the customer a notice."
            onClick={() => openInactiveModal(record)}
          >
            Inactive
          </Tag>
        );
      },
    },
    {
      // Billing/renewal standing — separate from Activity Status above.
      // Derived server-side (CustomerController.list) from the client's most
      // current contract (the one whose paid window ends latest): overdue if
      // that date has passed, due soon within the same 14-day window the
      // app's own paid-ending reminder cron uses, otherwise paid. A client
      // with no contract on file at all shows "No Contract".
      title: "Account Status",
      key: "accountStatus",
      width: 150,
      // Purely client-side (the backend has no accountStatus query param) —
      // onFilter/filteredValue still do the real filtering work against
      // whatever page of data is loaded, same as before. Switched off
      // AntD's default checkbox-list UI for this column too: its Reset
      // button only clears the checkboxes without confirming (a follow-up
      // OK click was needed to actually apply the reset) — same bug as
      // Activity Status, same custom-dropdown fix.
      filteredValue: rowFilter.accountStatus || null,
      onFilter: (value, record) => (record.accountStatus || "no_contract") === value,
      filterIcon: () => (
        <FilterFilled style={{ color: rowFilter.accountStatus?.length ? "#1890ff" : undefined }} />
      ),
      filterDropdown: ({ close }) => (
        <CheckboxFilterDropdown
          options={[
            { label: "Payment Overdue", value: "payment_overdue" },
            { label: "Contract Expired", value: "contract_expired" },
            { label: "Not Started", value: "not_started" },
            { label: "Upcoming Contract", value: "upcoming" },
            { label: "Renewal Due Soon", value: "renewal_due_soon" },
            { label: "Paid", value: "paid" },
            { label: "No Contract", value: "no_contract" },
          ]}
          initial={rowFilter.accountStatus || []}
          onApply={(vals) => setRowFilter((prev) => ({ ...prev, accountStatus: vals }))}
          onClose={close}
        />
      ),
      sorter: (a, b) => {
        const rank = { payment_overdue: 0, contract_expired: 1, not_started: 2, upcoming: 3, renewal_due_soon: 4, paid: 5, no_contract: 6 };
        return (rank[a.accountStatus] ?? 6) - (rank[b.accountStatus] ?? 6);
      },
      render: (_, record) => {
        const { accountStatus, accountStatusPaidUntil, accountStatusPaidFrom, accountStatusContractStartsOn } = record;
        // Demo accounts intentionally have no contract — show a clear Demo tag
        // instead of a misleading "No Contract" status.
        if (record.isDemo) {
          return <Tag color="purple">Internal (no contract)</Tag>;
        }
        const config = {
          payment_overdue: { color: "red", label: "Payment Overdue" },
          // Distinct from "Payment Overdue" — that means the contract's own
          // term is currently running but unpaid; this means the term
          // itself already ended with nothing further on file. Backend:
          // ContractStatusHelper.deriveAccountStatus.
          contract_expired: { color: "default", label: "Contract Expired" },
          not_started: { color: "default", label: "Not Started" },
          upcoming: { color: "blue", label: "Upcoming Contract" },
          renewal_due_soon: { color: "orange", label: "Renewal Due Soon" },
          paid: { color: "green", label: "Paid" },
          no_contract: { color: "default", label: "No Contract" },
        };
        const { color, label } = config[accountStatus] || config.no_contract;
        const tag = <Tag color={color}>{label}</Tag>;
        if (accountStatus === "not_started" && accountStatusContractStartsOn) {
          return (
            <Tooltip
              title={`Contract starts ${moment(accountStatusContractStartsOn).format("DD MMM YYYY")} — nothing due yet`}
            >
              {tag}
            </Tooltip>
          );
        }
        if (accountStatus === "upcoming" && accountStatusPaidFrom) {
          return (
            <Tooltip
              title={`Starts ${moment(accountStatusPaidFrom).format("DD MMM YYYY")}`}
            >
              {tag}
            </Tooltip>
          );
        }
        if (!accountStatusPaidUntil) return tag;
        return (
          <Tooltip
            title={`Paid until ${moment(accountStatusPaidUntil).format("DD MMM YYYY")}`}
          >
            {tag}
          </Tooltip>
        );
      },
    },
    {
      title: "Registration Date",
      key: "created_at",
      dataIndex: "created_at",
      sorter: (a, b) =>
        new Date(a.created_at || 0).getTime() - new Date(b.created_at || 0).getTime(),
      render: (_, { created_at }) => {
        return created_at ? moment(created_at).format("DD-MMM-YYYY") : emptyCell;
      },
    },
    {
      title: "Action",
      render: (_, record) => {
        const isInTrial = record.subscription?.isTrial;

        const moreMenu = (
          <Menu className="row-actions-menu">
            <Menu.Item
              key="view"
              onClick={() => {
                setVisibleView(true);
                setViewData(record);
              }}
              icon={<i className="fa fa-light fa-eye"></i>}
            >
              View Details
            </Menu.Item>
            {isInTrial && (
              <Menu.Item
                key="extend"
                onClick={() => handleExtendDays(record)}
                icon={<i className="fa fa-calendar-plus"></i>}
              >
                Extend Trial Days
              </Menu.Item>
            )}
            {isInTrial && (
              <Menu.Item
                key="paid"
                onClick={() => handleMarkAsPaid(record)}
                icon={<i className="fa fa-credit-card"></i>}
              >
                Mark as Paid
              </Menu.Item>
            )}
            <Menu.Item
              key="pause"
              onClick={() => {
                if (record.isPaused) {
                  resumeCustomer(record._id);
                } else {
                  openPauseModal(record);
                }
              }}
              icon={
                <i
                  className={record.isPaused ? "fa fa-play" : "fa fa-pause"}
                ></i>
              }
            >
              {record.isPaused ? "Resume Customer" : "Pause Customer"}
            </Menu.Item>
            <Menu.Item
              key="manage-assistants"
              onClick={() => navigate(`/view-clients/${record._id}?tab=assistants`)}
              icon={<i className="fa fa-user-plus"></i>}
            >
              Manage Assistants
            </Menu.Item>
            {permissionObject.delete && <Menu.Divider />}
            {permissionObject.delete && (
              <Menu.Item
                key="delete"
                danger
                onClick={() => showDeleteConfirm(record)}
                icon={<i className="fas fa-trash"></i>}
              >
                Delete Customer
              </Menu.Item>
            )}
          </Menu>
        );

        return (
          <div className="row-actions">
            {permissionObject.edit && (
              <Tooltip title="Edit">
                <button
                  className="row-action-btn row-action-edit"
                  onClick={() => {
                    record?.image && setFile([record.image]);
                    setSelected(record);
                    setVisible(true);
                  }}
                >
                  <i className="fa fa-light fa-pen"></i>
                </button>
              </Tooltip>
            )}

            {/* Demo accounts have no contract — access is granted via isSubscribed */}
            {!record.isDemo && (
              <Tooltip title="Manage Contracts">
                <button
                  className="row-action-btn row-action-contract"
                  onClick={() => {
                    setSelectedClientForContract({
                      id: record._id,
                      name: record.name,
                    });
                    setContractModalVisible(true);
                  }}
                >
                  <i className="fa fa-file-contract"></i>
                </button>
              </Tooltip>
            )}

            <Dropdown
              overlay={moreMenu}
              trigger={["click"]}
              placement="bottomRight"
            >
              <Tooltip title="More actions">
                <button className="row-action-btn row-action-more">
                  <i className="fa fa-ellipsis-h"></i>
                </button>
              </Tooltip>
            </Dropdown>
          </div>
        );
      },
    },
  ];

  const uploadFileToS3 = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const res = await axios.post(`${apiPath.baseURL}admin/media/upload`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return { Location: res.data?.data?.url };
  };

  const handleChangeImage = async (event) => {
    const { file } = event;
    let validateImage =
      file.type.includes("image") && !file.type.includes("svg");

    if (!validateImage) {
      return ShowToast("media not supported " + file.type, Severty.ERROR);
    }
    setFile([file]);
    try {
      const data = await uploadFileToS3(file);
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
    } catch (err) {
      console.error(err);
    }
  };

  const debouncedSearchText = useDebounce(searchText, 300);

  const navigate = useNavigate();
  const { confirm } = Modal;

  const deleteAccount = (record) => {
    setLoading(true);
    request({
      url: `${baseURL}/delete-account/${record ? record._id : ""}`,
      method: "PUT",
      onSuccess: (data) => {
        console.log(data, "data");
        setRefresh(!refresh);
        setLoading(false);
        ShowToast(data.message || "Account deleted successfully", Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error.response?.data?.message || error.message || error, Severty.ERROR);
      },
    });
  };

  // No bulk-delete endpoint on the backend, so several selected client
  // accounts are deleted with one PUT each, in parallel — same
  // delete-account route the single-row flow uses, just fired N times. Only
  // one success/error toast + refresh for the whole batch, not one per row.
  // Mirrors BrandManager.js's deleteUsers for the Staff table.
  const deleteAccounts = (ids) => {
    setLoading(true);
    Promise.allSettled(
      ids.map(
        (id) =>
          new Promise((resolve, reject) => {
            request({
              url: `${baseURL}/delete-account/${id}`,
              method: "PUT",
              onSuccess: resolve,
              onError: reject,
            });
          })
      )
    ).then((results) => {
      setLoading(false);
      setRefresh((prev) => !prev);
      setSelectedRowKeys([]);
      const failed = results.filter((r) => r.status === "rejected").length;
      if (failed === 0) {
        ShowToast(`${ids.length} account(s) deleted successfully`, Severty.SUCCESS);
      } else {
        ShowToast(
          `Deleted ${ids.length - failed} of ${ids.length} account(s); ${failed} failed`,
          failed === ids.length ? Severty.ERROR : Severty.SUCCESS
        );
      }
    });
  };

  // Same contract-status-warning spirit as showDeleteConfirm, rolled up
  // across every selected row — names every selected account and warns
  // once if ANY of them still has an active contract, rather than repeating
  // the warning per row. Mirrors BrandManager.js's showBulkDeleteConfirm.
  const showBulkDeleteConfirm = () => {
    const selectedRecords = list.filter((item) => selectedRowKeys.includes(item._id));
    const withActiveContract = selectedRecords.filter(
      (r) => !r.isDemo && ["paid", "renewal_due_soon", "payment_overdue"].includes(r.accountStatus)
    );
    confirm({
      title: "Delete Accounts",
      icon: <ExclamationCircleOutlined />,
      content: (
        <div className="delete-account-confirm-content">
          <p>
            Are you sure you want to delete these {selectedRecords.length} account
            {selectedRecords.length === 1 ? "" : "s"}?
          </p>
          <ul className="delete-account-confirm-list">
            {selectedRecords.map((r) => (
              <li key={r._id}>{r.name || r.userName || r.email}</li>
            ))}
          </ul>
          <p>This action cannot be undone.</p>
          {withActiveContract.length > 0 && (
            <div className="delete-account-confirm-warning">
              <WarningOutlined />
              <span>
                {withActiveContract.length} of these account{withActiveContract.length === 1 ? "" : "s"}{" "}
                {withActiveContract.length === 1 ? "has" : "have"} an active contract.
              </span>
            </div>
          )}
        </div>
      ),
      okText: "Yes, Delete All",
      okType: "danger",
      cancelText: "No",
      onOk() {
        deleteAccounts(selectedRowKeys);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const showDeleteConfirm = (record) => {
    // Wording matches what accountStatus actually means — "Payment
    // Overdue" is a LAPSED contract (the paid window already ended, just
    // unpaid), not a currently-running one, so it must not be called
    // "active". Only "paid"/"renewal_due_soon" describe a contract that is
    // genuinely live right now; "not_started"/"upcoming" haven't started
    // yet either. Demo accounts never have a contract (see the Account
    // Status column's own isDemo check above).
    const contractWarning = record.isDemo
      ? null
      : {
          paid: "This account has an active contract.",
          renewal_due_soon: "This account has an active contract due for renewal soon.",
          payment_overdue: "This account has an active contract that hasn't been paid.",
          contract_expired: "This account's contract has expired.",
          not_started: "This account has a contract that hasn't started yet.",
          upcoming: "This account has an upcoming contract.",
        }[record.accountStatus];
    confirm({
      title: "Delete Account",
      icon: <ExclamationCircleOutlined />,
      content: (
        <div className="delete-account-confirm-content">
          <p>
            Are you sure you want to delete <strong>{record.name || record.userName || "this account"}</strong>?
            This action cannot be undone.
          </p>
          {contractWarning && (
            <div className="delete-account-confirm-warning">
              {/* WarningOutlined, not ExclamationCircleOutlined — the modal's
                  own icon uses the latter, and a global
                  ".ant-modal-confirm-body ... .anticon-exclamation-circle"
                  rule (60px, blue, block) would hijack a second one nested
                  in this content and blow up its size. */}
              <WarningOutlined />
              <span>{contractWarning}</span>
            </div>
          )}
        </div>
      ),
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        deleteAccount(record);
      },
      onCancel() {
        console.log("Cancel delete");
      },
    });
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };

  // Open the reason modal when admin checks the pause box for a customer
  const openPauseModal = (record) => {
    setPauseTarget(record);
    pauseForm.resetFields();
    setPauseModalVisible(true);
  };

  // Submit pause with reason -> backend pauses customer + emails them
  const handlePauseSubmit = (values) => {
    if (!pauseTarget?._id) return;
    request({
      url: `${apiPath.customerPause}/${pauseTarget._id}`,
      method: "PUT",
      data: { paused: true, reason: values.reason },
      onSuccess: (data) => {
        ShowToast(data?.message || "Customer paused", Severty.SUCCESS);
        setPauseModalVisible(false);
        setPauseTarget(null);
        pauseForm.resetFields();
        setRefresh((prev) => !prev);
      },
      onError: (error) => {
        ShowToast(error?.response?.data?.message || "Failed to pause customer", Severty.ERROR);
      },
    });
  };

  // Open the reason modal when admin clicks an Inactive status tag
  const openInactiveModal = (record) => {
    setInactiveTarget(record);
    inactiveForm.resetFields();
    setInactiveModalVisible(true);
  };

  // Send the inactivity notice email with the admin's reason
  const handleInactiveSubmit = (values) => {
    if (!inactiveTarget?._id) return;
    request({
      url: `${apiPath.customerNotifyInactive}/${inactiveTarget._id}`,
      method: "PUT",
      data: { reason: values.reason },
      onSuccess: (data) => {
        ShowToast(data?.message || "Notice sent to customer", Severty.SUCCESS);
        setInactiveModalVisible(false);
        setInactiveTarget(null);
        inactiveForm.resetFields();
      },
      onError: (error) => {
        ShowToast(error?.response?.data?.message || "Failed to send notice", Severty.ERROR);
      },
    });
  };

  // Resume a paused customer (no reason needed)
  const resumeCustomer = (id) => {
    request({
      url: `${apiPath.customerPause}/${id}`,
      method: "PUT",
      data: { paused: false },
      onSuccess: (data) => {
        ShowToast(data?.message || "Customer resumed", Severty.SUCCESS);
        setRefresh((prev) => !prev);
      },
      onError: (error) => {
        ShowToast(error?.response?.data?.message || "Failed to resume customer", Severty.ERROR);
      },
    });
  };

  const statusChange = (record) => {
    setLoading(true);
    request({
      url: `${baseURL}/status-change/${record}?`,
      method: "PUT",
      onSuccess: (data) => {
        setRefresh((prev) => !prev);
        setLoading(false);
        ShowToast(data?.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const showConfirm = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want change the status ? </Button>,
        onOk() {
          statusChange(record);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  // New: Handle Extend Days
  const handleExtendDays = (record) => {
    setSelectedUserForExtend(record);
    setSelectedDays(1); // Default to 1 day
    setExtendDaysModalVisible(true);
  };

  // New: Handle Extend Submit
  const handleExtendSubmit = () => {

    setLoading(true);
    request({
      url: `${baseURL}/extend-trial/${selectedUserForExtend._id}`, // Placeholder endpoint
      method: "PUT",
      data: { days: selectedDays },
      onSuccess: (data) => {
        ShowToast(data.message || "Trial extended successfully!", Severty.SUCCESS);
        setRefresh((prev) => !prev);
        setExtendDaysModalVisible(false);
        setSelectedUserForExtend(null);
      },
      onError: (error) => {
        ShowToast(error.response?.data?.message || "Failed to extend trial.", Severty.ERROR);
      },
      onFinally: () => setLoading(false),
    });
  };

  // New: Handle Mark as Paid
  const handleMarkAsPaid = (record) => {
    confirm({
      title: "Mark as Paid",
      content: "Are you sure you want to mark this user as paid? This action cannot be undone.",
      onOk() {
        setLoading(true);
        request({
          url: `${baseURL}/mark-as-paid/${record._id}`, // Placeholder endpoint
          method: "PUT",
          onSuccess: (data) => {
            ShowToast(data.message || "User marked as paid!", Severty.SUCCESS);
            setRefresh((prev) => !prev);
          },
          onError: (error) => {
            ShowToast(error.response?.data?.message || "Failed to mark as paid.", Severty.ERROR);
          },
          onFinally: () => setLoading(false),
        });
      },
    });
  };

  useEffect(() => {
    setLoading(true);
    fetchData({ current: 1, pageSize: pagination.pageSize ?? 10 });
  }, [refresh, debouncedSearchText, startDate, endDate, customerFilter]);

  // Fetch all customers (respecting search/date filters) just to derive counts
  // shown on the Filter dropdown options. Kept separate from the paginated list call.
  useEffect(() => {
    request({
      url: `${baseURL}/list?status=&page=1&limit=100000&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""}&end_date=${endDate ? endDate : ""}`,
      method: "GET",
      onSuccess: (data) => {
        const docs = data?.data?.list?.docs || [];
        const active = docs.filter(
          (u) => u?.isActive === true && !u?.is_deleted
        ).length;
        const inactive = docs.filter(
          (u) => u?.isActive === false && !u?.is_deleted
        ).length;
        const trial = docs.filter(
          (u) => u?.subscription?.isTrial && !u?.subscription?.trialExpired
        ).length;
        setStatusCounts((prev) => ({ ...prev, all: docs.length, active, inactive, trial }));
      },
      onError: (error) => {
        console.log("status count fetch error", error);
      },
    });
    // Demo accounts are excluded from the default list above, so their count
    // needs its own demo=true call (totalDocs is enough — no need to load rows).
    request({
      url: `${baseURL}/list?demo=true&page=1&limit=1&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""}&end_date=${endDate ? endDate : ""}`,
      method: "GET",
      onSuccess: (data) => {
        setStatusCounts((prev) => ({ ...prev, demo: data?.data?.list?.totalDocs || 0 }));
      },
      onError: () => {},
    });
  }, [refresh, debouncedSearchText, startDate, endDate]);

  useEffect(() => {
    if (!visibleView) return;
    navigate(`/view-customer/${viewData._id}`);
  }, [visibleView]);

  // Column filter dropdown options — fetched once (and again on refresh, in
  // case a customer/assignment was just added) from every customer, so Name/
  // Email/Brand Manager/Brand Strategist filters cover the full list, not
  // just the currently loaded page.
  useEffect(() => {
    request({
      url: `${baseURL}/filter-options`,
      method: "GET",
      onSuccess: (data) => {
        const d = data?.data || {};
        setFilterOptions({
          names: d.names || [],
          emails: d.emails || [],
          brandManagers: d.brandManagers || [],
          brandStrategists: d.brandStrategists || [],
          assistants: d.assistants || [],
        });
      },
      onError: () => {},
    });
  }, [refresh]);

  const handleChange = (pagination, filters) => {
    setRowFilter(filters);
    fetchData(pagination, filters);
  };

  const fetchData = (pagination, filters) => {
    const f = filters || rowFilter;
    // The toolbar "Filter" dropdown (customerFilter) previously updated its
    // own state and even re-triggered this fetch (it's in the effect's
    // dependency array), but nothing here ever read it — this always fell
    // straight to `f.isActive`, a completely different state populated only
    // by the Activity Status column's own filter icon. Selecting Active/
    // Inactive/Trial Active in the toolbar dropdown looked like it worked
    // (the request count/highlight changed) but silently filtered nothing.
    // customerFilter now takes priority over the column's own filter when set.
    let statusValues = f.isActive;
    if (customerFilter === "active") statusValues = [true];
    else if (customerFilter === "inactive") statusValues = [false];
    else if (customerFilter === "trial") statusValues = undefined; // trial is its own axis below, not an activity status
    // "pause" is a separate flag from the Active/InActive booleans
    const paused = Array.isArray(statusValues) && statusValues.includes("pause");
    const filterActive = Array.isArray(statusValues)
      ? statusValues.filter((v) => v !== "pause")
      : statusValues;
    const nameValues = Array.isArray(f.name) ? f.name : [];
    const emailValues = Array.isArray(f.email) ? f.email : [];
    const bmValues = Array.isArray(f.brandManager) ? f.brandManager : [];
    const bsValues = Array.isArray(f.brandStrategist) ? f.brandStrategist : [];
    const assistantValues = Array.isArray(f.assistants) ? f.assistants : [];
    // "Trial Active" never had server-side support at all — the dropdown
    // option existed but nothing downstream could act on it. New trialFilter
    // param, mirrored on the backend (CustomerController.list).
    const trialActive = customerFilter === "trial";
    // Demo accounts are hidden by default; the "Demo Accounts" toolbar filter
    // sends demo=true so only they are listed (backend CustomerController.list).
    const demoOnly = customerFilter === "demo";
    request({
      url: `${baseURL}/list?demo=${demoOnly ? "true" : ""}&status=${filterActive && filterActive.length ? filterActive.join(",") : ""
        }&paused=${paused ? "true" : ""}&trialFilter=${trialActive ? "true" : ""}&page=${pagination ? pagination.current : 1}&limit=${pagination ? pagination.pageSize : 10
        }&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""
        }&end_date=${endDate ? endDate : ""
        }&nameFilter=${nameValues.length ? nameValues.map(encodeURIComponent).join(",") : ""
        }&emailFilter=${emailValues.length ? emailValues.map(encodeURIComponent).join(",") : ""
        }&bmFilter=${bmValues.length ? bmValues.join(",") : ""
        }&bsFilter=${bsValues.length ? bsValues.join(",") : ""
        }&assistantFilter=${assistantValues.length ? assistantValues.join(",") : ""}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.list.docs);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.data.list.totalDocs,
          pageSize: pagination.pageSize ?? 10,
        }));
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChangeDate = (e) => {
    setStartDate();
    setEndDate();
    setPagination((prev) => ({ ...prev, current: 1 }));
    if (e && e.length > 0) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
      setPagination((prev) => ({ ...prev, current: 1 }));
    }
  };

  const handleExportAllContracts = async () => {
    setLoading(true);
    try {
      // Fetch all customers
      const customersResponse = await new Promise((resolve, reject) => {
        request({
          url: `${baseURL}/list?status=&page=1&limit=10000&search=&start_date=&end_date=`,
          method: "GET",
          onSuccess: (data) => {
            console.log("Customers API Response:", data);
            resolve(data);
          },
          onError: (error) => {
            console.error("Error fetching customers:", error);
            reject(error);
          },
        });
      });

      // Handle different response structures - based on fetchData function
      let customers = [];
      if (customersResponse?.data?.list?.docs) {
        customers = customersResponse.data.list.docs;
      } else if (customersResponse?.data?.data?.list?.docs) {
        customers = customersResponse.data.data.list.docs;
      } else if (Array.isArray(customersResponse?.data)) {
        customers = customersResponse.data;
      } else if (Array.isArray(customersResponse?.data?.data)) {
        customers = customersResponse.data.data;
      } else if (customersResponse?.list?.docs) {
        customers = customersResponse.list.docs;
      } else if (Array.isArray(customersResponse)) {
        customers = customersResponse;
      }

      console.log("Total customers found:", customers.length);

      if (customers.length === 0) {
        ShowToast("No customers found to export", Severty.INFO);
        setLoading(false);
        return;
      }

      // Prepare Excel data
      const excelData = [];

      // Header row
      const headerRow = [
        // DETAILS section
        "S.No",
        "Client Name",
        "Business Development Manager",
        "Brand Manager",
        "Brand Strategist",
        "Company",
        "Designation",
        "Industry",
        "Location",
        // ORIGINAL CONTRACT section
        "Contract Start Date",
        "Contract End Date",
        "Contract Length (months)",
        "Pricing per month",
        "Payment Terms",
        // RENEWAL 1 section
        "Contract Start Date",
        "Contract End Date",
        "Contract Length (months)",
        "Pricing per month",
        "Payment Terms",
        // RENEWAL 2 section
        "Contract Start Date",
        "Contract End Date",
        "Contract Length (months)",
        "Pricing per month",
        "Payment Terms",
        // RENEWAL 3 section
        "Contract Start Date",
        "Contract End Date",
        "Contract Length (months)",
        "Pricing per month",
        "Payment Terms",
      ];
      excelData.push(headerRow);

      // Process each customer
      for (let i = 0; i < customers.length; i++) {
        const customer = customers[i];

        // Fetch customer details
        let customerDetails = null;
        try {
          const detailsResponse = await new Promise((resolve, reject) => {
            request({
              url: `${baseURL}/user-detail/${customer._id}`,
              method: "GET",
              onSuccess: (data) => {
                console.log(`Details for ${customer.name}:`, data);
                resolve(data);
              },
              onError: (error) => {
                console.error(`Error fetching details for ${customer.name}:`, error);
                reject(error);
              },
            });
          });

          // Handle different response structures
          if (detailsResponse?.data) {
            customerDetails = detailsResponse.data;
          } else if (detailsResponse) {
            customerDetails = detailsResponse;
          }
        } catch (error) {
          console.error(`Error fetching details for ${customer.name}:`, error);
          // Use customer data as fallback
          customerDetails = customer;
        }

        // Fetch contracts for this customer
        let contracts = [];
        try {
          const contractsResponse = await new Promise((resolve, reject) => {
            request({
              url: `${apiPath.contractByClient}/${customer._id}`,
              method: "GET",
              onSuccess: (data) => {
                console.log(`Contracts for ${customer.name}:`, data);
                resolve(data);
              },
              onError: (error) => {
                console.error(`Error fetching contracts for ${customer.name}:`, error);
                // Don't reject, just return empty array
                resolve({ data: { contracts: [] } });
              },
            });
          });

          let contractsData = [];
          if (contractsResponse?.data?.contracts) {
            contractsData = contractsResponse.data.contracts;
          } else if (contractsResponse?.data?.data?.contracts) {
            contractsData = contractsResponse.data.data.contracts;
          } else if (Array.isArray(contractsResponse?.data)) {
            contractsData = contractsResponse.data;
          } else if (contractsResponse?.contracts) {
            contractsData = contractsResponse.contracts;
          } else if (Array.isArray(contractsResponse)) {
            contractsData = contractsResponse;
          }

          contracts = Array.isArray(contractsData)
            ? contractsData.sort((a, b) => (a.renewalNumber || 0) - (b.renewalNumber || 0))
            : [];
        } catch (error) {
          console.error(`Error fetching contracts for ${customer.name}:`, error);
          contracts = [];
        }

        const originalContract = contracts.find(c => c.renewalNumber === 0);
        const renewals = contracts.filter(c => c.renewalNumber > 0).sort((a, b) => a.renewalNumber - b.renewalNumber);

        // Helper function to get name from brandManager/brandStrategist
        const getManagerNames = (managers) => {
          if (!managers || !Array.isArray(managers)) return "N/A";
          return managers
            .map(m => {
              if (typeof m === 'string') return m; // If it's just an ID string
              return m?.name || m?.userName || "N/A";
            })
            .filter(name => name !== "N/A")
            .join(", ") || "N/A";
        };

        // Create data row for this customer
        const dataRow = [
          // DETAILS
          i + 1, // S.No
          customer.name || customer.userName || customer.email || "N/A",
          "N/A", // Business Development Manager (not available in current schema)
          getManagerNames(customerDetails?.brandManager || customer?.brandManager),
          getManagerNames(customerDetails?.brandStrategist || customer?.brandStrategist),
          customerDetails?.company || customer?.company || "N/A",
          customerDetails?.designation || customer?.designation || "N/A",
          customerDetails?.industry || customer?.industry || "N/A",
          customerDetails?.location || customerDetails?.country || customer?.location || customer?.country || "N/A",
          // ORIGINAL CONTRACT
          originalContract
            ? moment(originalContract.startDate).format("DD-MMM-YYYY")
            : "dd-mm-yyyy",
          originalContract
            ? moment(originalContract.endDate).format("DD-MMM-YYYY")
            : "dd-mm-yyyy",
          originalContract?.contractLength || "N/A",
          originalContract ? `${contractCurrencySymbol(originalContract.currency)}${parseFloat(originalContract.amount).toFixed(2)}` : "N/A",
          originalContract?.paymentTerms || "N/A",
          // RENEWAL 1
          renewals[0]
            ? moment(renewals[0].startDate).format("DD-MMM-YYYY")
            : "dd-mm-yyyy",
          renewals[0]
            ? moment(renewals[0].endDate).format("DD-MMM-YYYY")
            : "dd-mm-yyyy",
          renewals[0]?.contractLength || "N/A",
          renewals[0] ? `${contractCurrencySymbol(renewals[0].currency)}${parseFloat(renewals[0].amount).toFixed(2)}` : "N/A",
          renewals[0]?.paymentTerms || "N/A",
          // RENEWAL 2
          renewals[1]
            ? moment(renewals[1].startDate).format("DD-MMM-YYYY")
            : "dd-mm-yyyy",
          renewals[1]
            ? moment(renewals[1].endDate).format("DD-MMM-YYYY")
            : "dd-mm-yyyy",
          renewals[1]?.contractLength || "N/A",
          renewals[1] ? `${contractCurrencySymbol(renewals[1].currency)}${parseFloat(renewals[1].amount).toFixed(2)}` : "N/A",
          renewals[1]?.paymentTerms || "N/A",
          // RENEWAL 3
          renewals[2]
            ? moment(renewals[2].startDate).format("DD-MMM-YYYY")
            : "dd-mm-yyyy",
          renewals[2]
            ? moment(renewals[2].endDate).format("DD-MMM-YYYY")
            : "dd-mm-yyyy",
          renewals[2]?.contractLength || "N/A",
          renewals[2] ? `${contractCurrencySymbol(renewals[2].currency)}${parseFloat(renewals[2].amount).toFixed(2)}` : "N/A",
          renewals[2]?.paymentTerms || "N/A",
        ];
        excelData.push(dataRow);
        console.log(`Processed customer ${i + 1}/${customers.length}: ${customer.name || customer.userName}`);
      }

      console.log("Total rows in Excel:", excelData.length);
      console.log("Sample row:", excelData[1] || "No data rows");

      if (excelData.length <= 1) {
        ShowToast("No data to export. Only header row found.", Severty.WARNING);
        setLoading(false);
        return;
      }

      // Create workbook and worksheet
      const ws = XLSX.utils.aoa_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "All Contracts");

      // Set column widths
      const colWidths = [
        { wch: 5 },   // S.No
        { wch: 20 },  // Client Name
        { wch: 30 },  // BD Manager
        { wch: 20 },  // Brand Manager
        { wch: 20 },  // Brand Strategist
        { wch: 15 },  // Company
        { wch: 15 },  // Designation
        { wch: 15 },  // Industry
        { wch: 15 },  // Location
        { wch: 18 },  // Original Start Date
        { wch: 18 },  // Original End Date
        { wch: 20 },  // Original Length
        { wch: 18 },  // Original Amount
        { wch: 15 },  // Original Payment Terms
        { wch: 18 },  // Renewal 1 Start
        { wch: 18 },  // Renewal 1 End
        { wch: 20 },  // Renewal 1 Length
        { wch: 18 },  // Renewal 1 Amount
        { wch: 15 },  // Renewal 1 Payment Terms
        { wch: 18 },  // Renewal 2 Start
        { wch: 18 },  // Renewal 2 End
        { wch: 20 },  // Renewal 2 Length
        { wch: 18 },  // Renewal 2 Amount
        { wch: 15 },  // Renewal 2 Payment Terms
        { wch: 18 },  // Renewal 3 Start
        { wch: 18 },  // Renewal 3 End
        { wch: 20 },  // Renewal 3 Length
        { wch: 18 },  // Renewal 3 Amount
        { wch: 15 },  // Renewal 3 Payment Terms
      ];
      ws['!cols'] = colWidths;

      // Export to file
      const fileName = `All_Clients_Contracts_${moment().format("YYYY-MM-DD")}.xlsx`;
      XLSX.writeFile(wb, fileName);
      ShowToast(`Exported ${customers.length} clients' contracts to Excel successfully`, Severty.SUCCESS);
      console.log("Excel file created successfully:", fileName);
    } catch (error) {
      console.error("Error exporting contracts:", error);
      ShowToast("Failed to export contracts to Excel", Severty.ERROR);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="tabled">
        <Row>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              id="cm-clients-table-card"
              className="criclebox tablespace mb-24 customer-table"
              title={
                <div className="cm-title">
                  <span className="cm-title-icon">
                    <i className="fa fa-users"></i>
                  </span>
                  <span className="cm-title-text">
                    <span className="cm-title-main">Customer Management</span>
                    <span className="cm-title-sub">
                      Manage clients, teams &amp; contracts
                    </span>
                  </span>
                </div>
              }
              extra={
                <Space wrap size={[10, 10]} align="center" className="gfx-toolbar">
                  <Search
                    size="large"
                    placeholder="Search by Name, Email"
                    onChange={onSearch}
                    title="Search by Name, Email, Number"
                    value={searchText}
                    onPressEnter={onSearch}
                  />

                  <RangePicker onChange={handleChangeDate} />

                  <Dropdown
                    trigger={["click"]}
                    overlay={
                      <Menu
                        selectable
                        selectedKeys={[customerFilter ?? "all"]}
                        onClick={({ key }) => {
                          setCustomerFilter(key === "all" ? null : key);
                          setPagination((prev) => ({
                            ...prev,
                            current: 1,
                          }));
                        }}
                      >
                        <Menu.Item key="all">
                          All{" "}
                          <Badge
                            count={statusCounts.all}
                            overflowCount={9999}
                            style={{
                              backgroundColor: "#8c8c8c",
                              marginLeft: 8,
                            }}
                          />
                        </Menu.Item>
                        <Menu.Item key="active">
                          Active{" "}
                          <Badge
                            count={statusCounts.active}
                            overflowCount={9999}
                            style={{
                              backgroundColor: "#52c41a",
                              marginLeft: 8,
                            }}
                          />
                        </Menu.Item>
                        <Menu.Item key="inactive">
                          Inactive{" "}
                          <Badge
                            count={statusCounts.inactive}
                            overflowCount={9999}
                            showZero
                            style={{
                              backgroundColor: "#ff4d4f",
                              marginLeft: 8,
                            }}
                          />
                        </Menu.Item>
                        <Menu.Item key="trial">
                          Trial Active{" "}
                          <Badge
                            count={statusCounts.trial}
                            overflowCount={9999}
                            showZero
                            style={{
                              backgroundColor: "#1890ff",
                              marginLeft: 8,
                            }}
                          />
                        </Menu.Item>
                        <Menu.Divider />
                        <Menu.Item key="demo">
                          Internal Accounts{" "}
                          <Badge
                            count={statusCounts.demo}
                            overflowCount={9999}
                            showZero
                            style={{
                              backgroundColor: "#722ed1",
                              marginLeft: 8,
                            }}
                          />
                        </Menu.Item>
                      </Menu>
                    }
                  >
                    <Button icon={<FilterFilled />}>
                      Filter
                      {customerFilter
                        ? ` : ${customerFilter === "active"
                            ? `Active (${statusCounts.active})`
                            : customerFilter === "inactive"
                              ? `Inactive (${statusCounts.inactive})`
                              : customerFilter === "demo"
                                ? `Internal (${statusCounts.demo})`
                                : `Trial Active (${statusCounts.trial})`
                          }`
                        : ""}
                    </Button>
                  </Dropdown>

                  <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                    onClick={handleExportAllContracts}
                    loading={loading}
                  >
                    Export All Contracts
                  </Button>
                  {permissionObject.add && (
                    <Button
                      type="primary"
                      onClick={(e) => {
                        setVisible(true);
                        setSearchText("");
                      }}
                    >
                      Add Customer
                    </Button>
                  )}
                  {/* Icon-only refresh — re-fetches this page's data in place
                      instead of making the user hard-reload the browser
                      tab, per direct request (same button added to
                      BrandManager.js and every other admin list module). */}
                  <Button
                    type="primary"
                    icon={<ReloadOutlined />}
                    title="Refresh"
                    onClick={() => setRefresh((prev) => !prev)}
                  />
                  {permissionObject.delete && selectedRowKeys.length > 0 && (
                    <Button
                      danger
                      icon={<DeleteOutlined />}
                      onClick={showBulkDeleteConfirm}
                    >
                      Delete Selected ({selectedRowKeys.length})
                    </Button>
                  )}
                </Space>
              }
            >
              <div className="table-responsive">
                <Table
                  rowKey="_id"
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  rowSelection={{
                    selectedRowKeys,
                    onChange: setSelectedRowKeys,
                    // Default antd selection column is a full-width column of
                    // its own — reads as too much next to the Client avatar
                    // it sits beside. Narrowed so it reads as a small
                    // checkbox tucked next to the avatar, not its own
                    // column. Same treatment as BrandManager.js's Staff
                    // table.
                    columnWidth: 36,
                  }}
                  // Required for the Client column's fixed:"left" to actually
                  // pin — AntD only activates sticky columns once it knows
                  // the table has real horizontal overflow to scroll within.
                  scroll={{ x: "max-content" }}
                  pagination={{
                    current: pagination?.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      {visible && (
        <AddForm
          file={file}
          setFile={setFile}
          handleChangeImage={handleChangeImage}
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
            setSearchText("");
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {provideSession && (
        <ChangePassword
          show={provideSession}
          hide={() => {
            setSelected();
            setProvideSession(false);
            setSearchText("");
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

  // {/* Extend Days Modal */}
      <Modal
        title="Extend Trial Days"
        visible={extendDaysModalVisible}
        onOk={handleExtendSubmit}
        onCancel={() => setExtendDaysModalVisible(false)}
        confirmLoading={loading}
      >
        <p>Enter the number of days to extend the trial:</p>
        <Input
          type="number"
          min={1}
          max={365}
          value={selectedDays}
          onChange={(e) => setSelectedDays(Number(e.target.value))}
          placeholder="Enter days "
          style={{ width: "100%" }}
        />
      </Modal>

      <Modal
        title="Comming Soon......"
        open={isRKModalVisible}
        onOk={() => setIsRKModalVisible(false)}
        onCancel={() => setIsRKModalVisible(false)}
      >
        <p>{modalContent}</p>
      </Modal>

      {/* Pause Customer Reason Modal */}
      <Modal
        title={`Pause Customer${pauseTarget?.name ? ` - ${pauseTarget.name}` : ""}`}
        open={pauseModalVisible}
        onCancel={() => {
          setPauseModalVisible(false);
          setPauseTarget(null);
          pauseForm.resetFields();
        }}
        footer={null}
        width={520}
      >
        <Form form={pauseForm} layout="vertical" onFinish={handlePauseSubmit}>
          <Form.Item
            label="Reason for pausing"
            name="reason"
            rules={[
              { required: true, message: "Please enter a reason" },
              {
                validator: (_, value) =>
                  value && value.trim()
                    ? Promise.resolve()
                    : Promise.reject(new Error("Reason cannot be empty")),
              },
            ]}
            extra="The customer will be emailed this reason and will be unable to log in until resumed."
          >
            <Input.TextArea rows={4} placeholder="Enter the reason for pausing this customer" />
          </Form.Item>
          <Form.Item>
            <Space size="middle">
              <Button type="primary" danger htmlType="submit">
                Pause & Notify
              </Button>
              <Button
                onClick={() => {
                  setPauseModalVisible(false);
                  setPauseTarget(null);
                  pauseForm.resetFields();
                }}
              >
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>

      {/* Inactivity Notice Modal */}
      <Modal
        title={`Send Inactivity Notice${inactiveTarget?.name ? ` - ${inactiveTarget.name}` : ""}`}
        open={inactiveModalVisible}
        onCancel={() => {
          setInactiveModalVisible(false);
          setInactiveTarget(null);
          inactiveForm.resetFields();
        }}
        footer={null}
        width={520}
      >
        <Form form={inactiveForm} layout="vertical" onFinish={handleInactiveSubmit}>
          <Form.Item
            label="Reason / message"
            name="reason"
            rules={[
              { required: true, message: "Please enter a reason" },
              {
                validator: (_, value) =>
                  value && value.trim()
                    ? Promise.resolve()
                    : Promise.reject(new Error("Reason cannot be empty")),
              },
            ]}
            extra="This customer has been inactive for 7+ days. The message below will be emailed to them. Their status returns to Active automatically when they use the app again."
          >
            <Input.TextArea rows={4} placeholder="Enter a message / reason for the customer" />
          </Form.Item>
          <Form.Item>
            <Space size="middle">
              <Button type="primary" htmlType="submit">
                Send Notice
              </Button>
              <Button
                onClick={() => {
                  setInactiveModalVisible(false);
                  setInactiveTarget(null);
                  inactiveForm.resetFields();
                }}
              >
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>

      {/* Contract Management Modal */}
      <ContractManagement
        clientId={selectedClientForContract?.id}
        clientName={selectedClientForContract?.name}
        visible={contractModalVisible}
        onClose={() => {
          setContractModalVisible(false);
          setSelectedClientForContract(null);
        }}
      />

    </>
  );
}

const AddForm = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState();
  const [users, setUsers] = useState([]);
  const [brandManagers, setBrandManagers] = useState([]);
  const [teamList, setTeamList] = useState([]);
  const [brandStrategists, setBrandStrategists] = useState([]);

  const FileType = ["image/png", "image/jpg", "image/jpeg", "image/webp"];
  const getSelectedBrandManagers = () => {
    const values = form.getFieldValue("brandManagers") || [];
    return values.filter(Boolean);
  };
  const getSelectedBrandStrategist = () => {
    const values = form.getFieldValue("brandStrategist") || [];
    return values.filter(Boolean);
  };

  const handleImage = (data) => {
    setImage(data?.[0]?.url || "");
    form.setFieldsValue({ image: data?.[0]?.url || "" });
  };
  useEffect(() => {
    request({
      url: `${baseURL}/brandManagerList`,
      method: "GET",
      onSuccess: (res) => {
        const allUsers = res.data.data || [];
        console.log(allUsers);
        setUsers(allUsers);
        setBrandManagers(allUsers.filter((u) => {
          const types = Array.isArray(u.type) ? u.type : [u.type];
          return types.includes("Brand Manager");
        }));
        setBrandStrategists(allUsers.filter((u) => {
          const types = Array.isArray(u.type) ? u.type : [u.type];
          return types.includes("Brand Strategist");
        }));
        setTeamList(allUsers.filter((u) => {
          const types = Array.isArray(u.type) ? u.type : [u.type];
          return types.includes("Brand Head");
        }));
      },
    });
  }, []);
  // useEffect(() => {
  //   request({
  //     url: `${apiPath.teamList}/team-list`,
  //     method: "GET",
  //     onSuccess: (res) => {
  //       console.log(res.data, "data")
  //       setTeamList(res.data.data)

  //     },
  //   });
  // }, []);

  // Populate form for edit mode
  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        ...data,
        profileImage: data?.image,
        brandManagers: data?.brandManager?.map((bm) => bm._id) || [],
        brandStrategist: data?.brandStrategist?.map((bs) => bs._id) || [],
        brandHead: Array.isArray(data?.brandHead) ? data.brandHead[0] : data.brandHead,
      });
      setImage(data?.image);
    }
  }, [data]);


  const onCreate = (values) => {
    console.log(values, "values");
    const payload = {
      name: values.name,
      ar_name: values.ar_name,
      alias: values.alias,
      email: values.email,
      profileImage: image,
      brandManager: values.brandManagers,
      brandStrategist: values.brandStrategist,
      brandHead: [values.brandHead],
    };

    // Account type (trial vs no-trial) only applies when creating a new customer
    if (!data) {
      // A BD demo account skips the whole trial/contract/onboarding path —
      // access is granted immediately (backend sets isSubscribed). An optional
      // password lets the BD member log in right away; if omitted, the usual
      // welcome/reset-password email is still sent.
      if (values.isDemo) {
        payload.isDemo = true;
        if (values.password) payload.password = values.password;
      } else {
        payload.isTrial = values.accountType === "trial";
      }
    }


    setLoading(true);
    request({
      url: `${data ? `${baseURL}/edit-user/${data._id}` : `${baseURL}/add-customer`
        }`,
      method: data ? "PUT" : "POST",
      data: payload,
      onSuccess: (res) => {
        setLoading(false);
        ShowToast(res.message, Severty.SUCCESS);
        hide();
        refresh();
      },
      onError: (err) => {
        setLoading(false);
        ShowToast(err.response.data.message, Severty.ERROR);
      },
    });
  };

  return (
    <Modal
      open={show}
      onCancel={loading ? undefined : hide}
      width={720}
      title={data ? "Edit Customer" : "Add Customer"}
      okText={loading ? (data ? "Saving..." : "Creating account...") : "OK"}
      okButtonProps={{ form: "add-customer", htmlType: "submit", loading }}
      cancelButtonProps={{ disabled: loading }}
      maskClosable={!loading}
      keyboard={!loading}
    >
      <Form
        id="add-customer"
        layout="vertical"
        form={form}
        onFinish={onCreate}
        initialValues={{ accountType: "trial" }}
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Full Name"
              name="name"
              rules={[
                { required: true, message: "Name is required" },
                {
                  validator: (_, value) => {
                    if (!value || value.trim() === "") {
                      return Promise.reject(new Error("Name cannot be only spaces"));
                    }
                    if (/^\d+$/.test(value.trim())) {
                      return Promise.reject(new Error("Name cannot be only numbers"));
                    }
                    return Promise.resolve();
                  },
                },
                {
                  max: 100,
                  message: "Name cannot exceed 100 characters",
                },
              ]}
            >
              <Input placeholder="Enter Full Name" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Alias"
              name="alias"
              rules={[
                {
                  max: 100,
                  message: "Alias cannot exceed 100 characters",
                },
              ]}
            >
              <Input placeholder="Enter Alias If you have" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Full Name (Arabic)"
              name="ar_name"
              rules={[]}
            >
              <Input placeholder="Enter Full Name (Arabic)" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Please enter an email address" },
                { type: "email", message: "Invalid email format" },
                { max: 100, message: "Email should not exceed 100 characters" },
              ]}
            >
              <Input placeholder="Enter email" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.List name="brandManagers">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => {
                    const selectedIds = getSelectedBrandManagers();
                    return (
                      <Row gutter={16} key={key}>
                        <Col span={fields.length > 1 ? 22 : 24}>
                          <Form.Item
                            {...restField}
                            label={index === 0 ? "Brand Manager" : ""}
                            name={[name]}
                            rules={[
                              {
                                required: true,
                                message: "Please select a brand manager",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select Brand Manager"
                              allowClear
                              style={{ width: "100%" }}
                              onChange={() => {
                                form.setFieldsValue({
                                  brandManagers: getSelectedBrandManagers(),
                                });
                              }}
                            >
                              {brandManagers
                                .filter(
                                  (user) =>
                                    !selectedIds.includes(user._id) ||
                                    user._id ===
                                    form.getFieldValue([
                                      "brandManagers",
                                      name,
                                    ])
                                )
                                .map((user) => (
                                  <Option key={user._id} value={user._id}>
                                    {user.name}
                                  </Option>
                                ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={2}>
                          {fields.length > 1 ? (
                            <MinusCircleOutlined onClick={() => remove(name)} />
                          ) : null}
                        </Col>
                      </Row>
                    );
                  })}
                  <Form.Item>
                    <Button
                      className="add-brand-button"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                    >
                      Add Brand Manager
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Col>
          <Col span={12}>
            <Form.List name="brandStrategist">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => {
                    const selectedIds = getSelectedBrandStrategist();
                    return (
                      <Row gutter={16} key={key}>
                        <Col span={fields.length > 1 ? 22 : 24}>
                          <Form.Item
                            {...restField}
                            label={index === 0 ? "Brand Strategist" : ""}
                            name={[name]}
                            rules={[
                              {
                                required: true,
                                message: "Please select a brand strategist",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select Brand Strategist"
                              allowClear
                              style={{ width: "100%" }}
                              onChange={() => {
                                form.setFieldsValue({
                                  brandStrategist: getSelectedBrandStrategist(),
                                });
                              }}
                            >
                              {brandStrategists
                                .filter(
                                  (user) =>
                                    !selectedIds.includes(user._id) ||
                                    user._id ===
                                    form.getFieldValue([
                                      "brandStrategist",
                                      name,
                                    ])
                                )
                                .map((user) => (
                                  <Option key={user._id} value={user._id}>
                                    {user.name}
                                  </Option>
                                ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={2}>
                          {fields.length > 1 ? (
                            <MinusCircleOutlined onClick={() => remove(name)} />
                          ) : null}
                        </Col>
                      </Row>
                    );
                  })}
                  <Row>
                    <Col span={24}>
                      <Form.Item>
                        <Button
                          className="add-brand-button"
                          onClick={() => add()}
                          block
                          icon={<PlusOutlined />}
                        >
                          Add Brand Strategist
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}
            </Form.List>
          </Col>

          <Col span={12}>
            <Form.Item label="Brand Head" name="brandHead">
              <Select allowClear placeholder="Select Brand Head">
                {teamList.map((user) => (
                  <Option key={user._id} value={user._id}>
                    {user.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          {!data && (
            <Col span={24}>
              <Form.Item
                name="isDemo"
                valuePropName="checked"
                style={{ marginBottom: 8 }}
              >
                <Switch
                  checkedChildren="Internal"
                  unCheckedChildren="Internal"
                  style={{ marginRight: 10 }}
                />
              </Form.Item>
              <span style={{ display: "block", marginTop: -4, marginBottom: 12, color: "#888", fontSize: 12 }}>
                Internal account (Business Development) &mdash; no contract, no onboarding
                (LinkedIn connect only), access granted immediately.
              </span>
            </Col>
          )}

          {/* Account Type only applies to real customers — hidden for demo accounts */}
          {!data && (
            <Form.Item noStyle shouldUpdate={(prev, cur) => prev.isDemo !== cur.isDemo}>
              {({ getFieldValue }) =>
                getFieldValue("isDemo") ? (
                  <Col span={24}>
                    <Form.Item
                      className="demo-password-item"
                      label="Login Password (optional)"
                      name="password"
                      tooltip="Set a password so the BD member can log in immediately — it's included in their welcome email. Leave blank to send a set-password link instead."
                      rules={[
                        {
                          validator: (_, value) => {
                            if (!value) return Promise.resolve();
                            if (value.length < 8) {
                              return Promise.reject(
                                new Error("Password must be at least 8 characters long")
                              );
                            }
                            if (!/^(?=.*[A-Z])(?=.*\d)(?=.*[a-z]).+$/.test(value)) {
                              return Promise.reject(
                                new Error(
                                  "Password must contain an uppercase letter, a lowercase letter and a number"
                                )
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input.Password
                        className="demo-password-input"
                        style={{ width: "100%" }}
                        placeholder="Optional — leave blank to email a reset-password link instead"
                        visibilityToggle
                        addonAfter={
                          <span
                            role="button"
                            onClick={() =>
                              form.setFieldsValue({ password: generateDemoPassword() })
                            }
                            style={{ cursor: "pointer", color: "#185250", fontWeight: 500, whiteSpace: "nowrap" }}
                          >
                            Generate
                          </span>
                        }
                      />
                    </Form.Item>
                    <p style={{ margin: "-8px 0 0", fontSize: 12, color: "#888" }}>
                      A generated/typed password is sent to the internal user's email &mdash;
                      it isn't shown again after this form closes.
                    </p>
                  </Col>
                ) : (
                  <Col span={24}>
                    <Form.Item
                      label="Account Type"
                      name="accountType"
                      rules={[{ required: true, message: "Please select an account type" }]}
                    >
                      <Radio.Group>
                        <Radio value="trial">
                          Trial (14-day free trial &mdash; access granted now)
                        </Radio>
                        <Radio value="no_trial">
                          No Trial (access starts after a contract is created)
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                )
              }
            </Form.Item>
          )}
          <Col span={12}>
            <Form.Item
              name="image"
            // rules={[
            //   {
            //     validator: (_, value) => {
            //       if (value !== undefined && value?.length > 0) {
            //         return Promise.resolve();
            //       }
            //       return Promise.reject(new Error("Image is required"));
            //     },
            //   },
            // ]}
            >
              <SingleImageUpload
                value={image}
                fileType={FileType}
                imageType={"Profile"}
                btnName={"Profile Image"}
                onChange={(data) => handleImage(data)}
                isDimension={false}
              />
            </Form.Item>
            <p className="img-size-details">
              ** Images should be in (.png, .jpeg, .jpg) format and up to 5 MB
              **
            </p>

            {image && (
              <div className="mt-2 add-img-product mb-4">
                <Image width={120} src={image} />
              </div>
            )}
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const ChangePassword = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();

  const [loading, setLoading] = useState(false);
  const onCreate = (values) => {
    setLoading(true);
    request({
      url: `${baseURL}/reset-password/${data._id}`,
      method: `PUT`,
      data: values,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
          // hide()
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        // console.log(error.response.data, "Error")
        setLoading(false);
      },
      // onErrorSubmit: (data) => {
      //   console.log(data)
      // }
    });
    // console.log(values)
  };

  return (
    <Modal
      visible={show}
      title={`${data ? "Change password" : "Create a new User"} `}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row gutter={[0, 0]}>
          <Col span={24}>
            <Form.Item
              label="New Password"
              name="new_password"
              hasFeedback
              rules={[
                { required: true, message: "Please input the new password!" },
                {
                  min: 8,
                  message: "Password must be at least 8 characters long!",
                },
                {
                  pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z]).+$/,
                  message:
                    "Password must contain at least one uppercase letter, one number, and one lowercase letter!",
                },
                {
                  max: 100,
                  message: "Title cannot exceed 100 characters",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Confirm New Password"
              name="confirm_new_password"
              dependencies={["new_password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please input the confirm password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Passwords that you entered do not match!")
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default User;
